export default __webpack_public_path__ + "static/media/our-culture-section.2d816371.jpg";